import React from 'react';
import { Menu, MenuItem } from 'react-pro-sidebar';
import { Backdrop, Grid } from '@mui/material';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useData } from '../../contexts';
import { navigate } from 'gatsby';
import { MdClose } from 'react-icons/md';

export const InfoPanel = (props: any) => {
  const { allIndicators, data, interactieveToolPath } = props;

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { interfaceColor, selectedGemeente, setSearchParams } = useData();

  return (
    <div
      className={'vl-typography'}
      style={{
        float: 'right',
        // marginLeft: 'auto',
        marginRight: '8px',
        cursor: 'pointer',
        paddingRight: '8px',
        paddingLeft: '8px',
        textDecoration: 'underline',
        color: interfaceColor,
        borderRadius: 12,
        position: 'relative',
        top: '18px',
      }}
    >
      <p onClick={handleOpen} style={{ marginBottom: 0 }}>
        Meer informatie
      </p>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        slots={{ backdrop: Backdrop, baseTooltip: null }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: 'rgba(255, 255, 255, 0,5)',
            },
          },
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: 1000,
            maxHeight: '90%',
            height: '90%',
            width: '90vw',
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            overflowY: 'auto',
          }}
          className={'vl-typography'}
          id="selectionScreenBox"
        >
          <Grid container>
            <Grid item xs={12}>
              <h2 style={{ fontSize: 18, float: 'left' }}>Meer info</h2>

              <button
                onClick={handleClose}
                style={{
                  color: interfaceColor,
                  width: '30px',
                  float: 'right',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  marginLeft: '12px',
                  position: 'relative',
                  top: '0px',
                  right: '0px',
                  fontSize: '24px',
                  border: 'none',
                }}
              >
                <span className="vl-button__label">
                  <MdClose />
                </span>
              </button>
              <p style={{ clear: 'both' }}>
                Klik op onderstaande links om meer informatie te bekomen over de
                indicatoren (definitie, bron…) of om ze rechtstreeks in de
                interactieve toepassing meer in detail te bekijken.
              </p>
              <Menu
                style={{
                  paddingTop: '24px',
                }}
                menuItemStyles={{
                  button: ({ level, active, disabled }) => {
                    return {
                      paddingLeft: '24px',
                      paddingRight: '24px',
                      listStyleType: 'none',
                      height: '50px',
                    };
                  },
                }}
              >
                {data.map((d: any, i: number) => {
                  return (
                    <MenuItem style={{ cursor: 'default' }}>
                      <p
                        style={{
                          paddingTop: '18px',
                          float: 'left',
                          width: '400px',
                        }}
                      >
                        {d.label}
                      </p>
                      <p
                        onClick={() => {
                          const ind = allIndicators.find((a: any) => {
                            return a.field_indicator_id === d.detail.ido;
                          });

                          window.open(`${ind.path.alias}`, '_blank');
                        }}
                        style={{
                          paddingTop: '18px',
                          float: 'left',
                          width: '150px',

                          color: interfaceColor,
                          textDecoration: 'underline',
                          cursor: 'pointer',
                        }}
                      >
                        Informatie
                      </p>
                      <p
                        onClick={() => {
                          setSearchParams((params) => {
                            params.set('gemeente', selectedGemeente?.ruimte);
                            params.set('indicator', d.detail.ido);
                            return params;
                          });

                          window.open(
                            `${interactieveToolPath}?gemeente=${selectedGemeente?.ruimte}&indicator=${d?.detail?.ido}`,
                            '-blank',
                          );
                        }}
                        style={{
                          paddingTop: '18px',
                          float: 'left',
                          width: '150px',
                          color: interfaceColor,
                          textDecoration: 'underline',
                          cursor: 'pointer',
                        }}
                      >
                        Interactieve toepassing
                      </p>
                    </MenuItem>
                  );
                })}
              </Menu>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};
